import { X } from 'lucide-react';
import { Badge } from '../badge';

type FilterPillProps = {
  label: string;
  onRemove: () => void;
  removeLabel?: string;
  disabled?: boolean;
};

// gloss
const FilterPill = ({ label, onRemove, removeLabel = `Remove ${label} filter`, disabled = false }: FilterPillProps) => {
  return (
    <Badge data-slot="filter-pill" variant="secondary" className="font-normal">
      {label}
      <button
        type="button"
        onClick={onRemove}
        aria-label={removeLabel}
        disabled={disabled}
        data-icon="inline-end"
        className="disabled:pointer-events-none disabled:opacity-50"
      >
        <X className="size-2.5" />
      </button>
    </Badge>
  );
};

export type { FilterPillProps };
export { FilterPill };
